export const CHANNEL_CALENDAR_APPEND_STRING = '_CHANNELTEAMSTYPE_';
